import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChangePasswordDialogComponent } from '../components/change-password-dialog/change-password-dialog.component';
import { BaseModalSize } from '@shared/ui/modal';
import { ChangePinDialogComponent } from '../components/change-pin-dialog/change-pin-dialog.component';
import { ChangeProfileDialogComponent } from '../components/change-profile-dialog/change-profile-dialog.component';
import { DownloadAllEvidenceDialogComponent } from '../components/download-all-evidence-dialog/download-all-evidence-dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class LayoutModalService {
  private ref!: DynamicDialogRef | null;

  constructor(public dialogService: DialogService) {}

  openPassword(): Observable<boolean> {
    this.ref = this.dialogService.open(ChangePasswordDialogComponent, {
      width: BaseModalSize.Large,
      modal: true,
    });

    return this.wrapCloseResult(this.ref);
  }

  openChangePinModal(): void {
    this.dialogService.open(ChangePinDialogComponent, { width: BaseModalSize.Large, modal: true });
  }

  openChangeProfileModal(): void {
    this.dialogService.open(ChangeProfileDialogComponent, { width: BaseModalSize.Large, modal: true });
  }

  openDownloadAllEvidenceDialog(hasLockedEvidence: boolean): Observable<boolean> {
    this.ref = this.dialogService.open(DownloadAllEvidenceDialogComponent, {
      data: { hasLockedEvidence: hasLockedEvidence },
      width: BaseModalSize.Large,
      modal: true,
    });

    return this.wrapCloseResult(this.ref);
  }

  private wrapCloseResult(ref: DynamicDialogRef | null): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (!ref) {
        observer.next(false);
        observer.complete();
        return;
      }

      ref.onClose.subscribe((result) => {
        observer.next(!!result);
        observer.complete();
      });
    });
  }
}
